export default "__VITE_ASSET__3b9b87c8__"